import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { featuredBooks } from "../../redux/books/actions";
import fetchBooks from "../../redux/books/thunk/fetchBooks";

const Filter = () => {
  const dispatch = useDispatch();
  const { showFeatured } = useSelector((state) => state.books);
  return (
    <div className="flex items-center space-x-4">
      <button
        className={`filter-btn ${!showFeatured && "active-filter"}`}
        id="lws-filterAll"
        onClick={() => dispatch(fetchBooks())}
      >
        All
      </button>
      <button
        className={`filter-btn ${showFeatured && "active-filter"}`}
        id="lws-filterFeatured"
        onClick={() => dispatch(featuredBooks())}
      >
        Featured
      </button>
    </div>
  );
};

export default Filter;
